"use client";

import type { ReactNode } from "react";

type BadgeProps = {
  children: ReactNode;
  icon?: ReactNode;
  /** Pre-mixed colors so call sites don't need runtime color math. Defaults reproduce the hero's teal "Real-Time Protection" badge. */
  borderColor?: string;
  backgroundColor?: string;
  textColor?: string;
  className?: string;
};

/**
 * Small uppercase pill badge with an optional leading icon - the
 * "REAL-TIME PROTECTION" treatment from the reference design, generalized
 * so any section can reuse the same shape with a different tint.
 */
export default function Badge({
  children,
  icon,
  borderColor = "rgba(45,212,191,0.4)",
  backgroundColor = "rgba(45,212,191,0.08)",
  textColor = "var(--color-teal, #2dd4bf)",
  className = "",
}: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] ${className}`}
      style={{ borderColor, backgroundColor, color: textColor }}
    >
      {icon}
      {children}
    </span>
  );
}
